/* Shto heroes (shto-hero and every hero root marked data-shto-hero). The big button: a smooth scroll to the buy box (or wherever the button's link points on this page).
   The store's header hides while the page scrolls down and shows again while it scrolls up (theme-scripts.js), so
   going down the target lands at the top of the screen, going up it lands under the header. No motion when the
   visitor asks for reduced motion. The link carries the theme's noScroll class so the theme's own anchor scroll
   doesn't run as well. Runs once even if the section is on the page twice. */
(function () {
  if (window.shtoHeroScroll) return;
  window.shtoHeroScroll = true;
  // An address ending in one of our section ids (#shto-product-buy ...) opens at the top of the page, not at that section,
  // and the ending is removed. Old shared links carry it from before buttons stopped writing it (Kevin 2026-10-02).
  if (/^#shto-/.test(location.hash) && history.replaceState) {
    history.replaceState(history.state, '', location.pathname + location.search);
    var toTop = function () { window.scrollTo(0, 0); };
    toTop();
    document.addEventListener('DOMContentLoaded', toTop);
    window.addEventListener('load', function () { toTop(); setTimeout(toTop, 0); });
  }
  function headerHeight() {
    var header = document.getElementById('header');
    if (!header) return 0;
    var pos = getComputedStyle(header).position;
    return pos === 'fixed' || pos === 'sticky' ? header.offsetHeight : 0;
  }
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-shto-hero] [data-shto-scroll-link], [data-shto-section="shto-hero"] [data-shto-scroll-link]');
    if (!link) return;
    var hash = link.getAttribute('href') || '';
    if (hash.charAt(0) !== '#' || hash.length < 2) return;
    var target = document.getElementById(decodeURIComponent(hash.slice(1)));
    if (!target) return;
    event.preventDefault();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var distance = target.getBoundingClientRect().top;
    var top = distance + window.pageYOffset - (distance < 0 ? headerHeight() : 0);
    window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
    // Never write the target into the address bar (Kevin 2026-10-02): a copied or reloaded address would open at the buy box.
  });
})();
